export const extraRenames = [
  { old: "Priestess Robe", new: "Sacramental Robe" },
  { old: "Soldiering Greaves", new: "Plated Greaves" },
  { old: "Veteran Greaves", new: "Bulwark Greaves" },
]

export const baseTypeMigrationData = [
  { old: "Advanced Smithing Hammer", new: "Calescent Hammer" },
  { old: "Advanced Slim Mace", new: "Flared Mace" },
  { old: "Advanced Warpick", new: "Battle Pick" },
  { old: "Advanced Plated Mace", new: "Marching Mace" },
  { old: "Advanced Brigand Mace", new: "Bandit Mace" },
  { old: "Advanced Construct Hammer", new: "Structured Hammer" },
  { old: "Advanced Oak Greathammer", new: "Snakewood Greathammer" },
  { old: "Advanced Forge Maul", new: "Blacksmith Maul" },
  { old: "Advanced Cultist Greathammer", new: "Zealot Greathammer" },
  { old: "Advanced Temple Maul", new: "Solemn Maul" },
  { old: "Advanced Leaden Greathammer", new: "Heavy Greathammer" },
  { old: "Advanced Crumbling Maul", new: "Disintegrating Maul" },
  { old: "Expert Slim Mace", new: "Flanged Mace" },
  { old: "Expert Plated Mace", new: "Crown Mace" },
  { old: "Expert Smithing Hammer", new: "Molten Hammer" },
  { old: "Expert Warpick", new: "Strife Pick" },
  { old: "Expert Construct Hammer", new: "Fortified Hammer" },
  { old: "Expert Brigand Mace", new: "Marauding Mace" },
  { old: "Expert Forge Maul", new: "Anvil Maul" },
  { old: "Expert Temple Maul", new: "Sacred Maul" },
  { old: "Expert Oak Greathammer", new: "Ironwood Greathammer" },
  { old: "Expert Cultist Greathammer", new: "Fanatic Greathammer" },
  { old: "Expert Crumbling Maul", new: "Ruination Maul" },
  { old: "Expert Leaden Greathammer", new: "Massive Greathammer" },
  { old: "Advanced Gothic Quarterstaff", new: "Barbarous Quarterstaff" },
  { old: "Advanced Crackling Quarterstaff", new: "Arcing Quarterstaff" },
  { old: "Advanced Crescent Quarterstaff", new: "Waxing Quarterstaff" },
  { old: "Advanced Slicing Quarterstaff", new: "Bladed Quarterstaff" },
  { old: "Advanced Barrier Quarterstaff", new: "Guardian Quarterstaff" },
  { old: "Expert Gothic Quarterstaff", new: "Sinister Quarterstaff" },
  { old: "Expert Crescent Quarterstaff", new: "Lunar Quarterstaff" },
  { old: "Expert Crackling Quarterstaff", new: "Bolting Quarterstaff" },
  { old: "Expert Barrier Quarterstaff", new: "Aegis Quarterstaff" },
  { old: "Expert Slicing Quarterstaff", new: "Razor Quarterstaff" },
  { old: "Advanced Shortbow", new: "Snakewood Shortbow" },
  { old: "Advanced Warden Bow", new: "Protector Bow" },
  { old: "Advanced Composite Bow", new: "Rider Bow" },
  { old: "Advanced Dualstring Bow", new: "Twin Bow" },
  { old: "Advanced Cultist Bow", new: "Adherent Bow" },
  { old: "Advanced Zealot Bow", new: "Militant Bow" },
  { old: "Expert Shortbow", new: "Ironwood Shortbow" },
  { old: "Expert Composite Bow", new: "Cavalry Bow" },
  { old: "Expert Warden Bow", new: "Guardian Bow" },
  { old: "Expert Dualstring Bow", new: "Gemini Bow" },
  { old: "Expert Cultist Bow", new: "Fanatic Bow" },
  { old: "Expert Zealot Bow", new: "Warmonger Bow" },
  { old: "Advanced Long Quarterstaff", new: "Reaching Quarterstaff" },
  { old: "Advanced Tense Crossbow", new: "Taut Crossbow" },
  { old: "Advanced Sturdy Crossbow", new: "Robust Crossbow" },
  { old: "Advanced Varnished Crossbow", new: "Painted Crossbow" },
  { old: "Advanced Dyad Crossbow", new: "Twin Crossbow" },
  { old: "Advanced Bombard Crossbow", new: "Cannonade Crossbow" },
  { old: "Advanced Forlorn Crossbow", new: "Bleak Crossbow" },
  { old: "Expert Long Quarterstaff", new: "Striking Quarterstaff" },
  { old: "Expert Sturdy Crossbow", new: "Stout Crossbow" },
  { old: "Expert Varnished Crossbow", new: "Engraved Crossbow" },
  { old: "Expert Tense Crossbow", new: "Flexed Crossbow" },
  { old: "Expert Dyad Crossbow", new: "Gemini Crossbow" },
  { old: "Expert Bombard Crossbow", new: "Siege Crossbow" },
  { old: "Expert Forlorn Crossbow", new: "Desolate Crossbow" },
  { old: "Advanced Ironhead Spear", new: "Steelhead Spear" },
  { old: "Advanced Hunting Spear", new: "Coursing Spear" },
  { old: "Advanced War Spear", new: "Swift Spear" },
  { old: "Advanced Forked Spear", new: "Branched Spear" },
  { old: "Advanced Barbed Spear", new: "Jagged Spear" },
  { old: "Advanced Broad Spear", new: "Massive Spear" },
  { old: "Expert Ironhead Spear", new: "Orichalcum Spear" },
  { old: "Expert Forked Spear", new: "Pronged Spear" },
  { old: "Expert Hunting Spear", new: "Stalking Spear" },
  { old: "Expert War Spear", new: "Flying Spear" },
  { old: "Expert Broad Spear", new: "Grand Spear" },
  { old: "Expert Barbed Spear", new: "Spiked Spear" },
  { old: "Advanced Fur Plate", new: "Barbarian Plate" },
  { old: "Advanced Iron Cuirass", new: "Rugged Cuirass" },
  { old: "Advanced Maraketh Cuirass", new: "Sandsworn Cuirass" },
  { old: "Advanced Steel Plate", new: "Elegant Plate" },
  { old: "Advanced Full Plate", new: "Heavy Plate" },
  { old: "Advanced Vaal Cuirass", new: "Stone Cuirass" },
  { old: "Expert Iron Cuirass", new: "Soldier Cuirass" },
  { old: "Expert Steel Plate", new: "Ornate Plate" },
  { old: "Expert Vaal Cuirass", new: "Utzaal Cuirass" },
  { old: "Advanced Quilted Vest", new: "Patchwork Vest" },
  { old: "Advanced Pathfinder Coat", new: "Hunting Coat" },
  { old: "Advanced Rhoahide Coat", new: "Riding Coat" },
  { old: "Advanced Studded Vest", new: "Layered Vest" },
  { old: "Advanced Scout's Vest", new: "Runner Vest" },
  { old: "Advanced Serpentscale Coat", new: "Lizardscale Coat" },
  { old: "Expert Pathfinder Coat", new: "Swiftstalker Coat" },
  { old: "Expert Studded Vest", new: "Slipstrike Vest" },
  { old: "Expert Serpentscale Coat", new: "Wyrmscale Coat" },
  { old: "Advanced Feathered Robe", new: "Avian Robe" },
  { old: "Advanced Hexer's Robe", new: "Cursespeaker's Robe" },
  { old: "Advanced Silk Robe", new: "Luxurious Robe" },
  { old: "Advanced Keth Raiment", new: "River Raiment" },
  { old: "Advanced Votive Raiment", new: "Adherent's Raiment" },
  { old: "Advanced Altar Robe", new: "Ceremonial Robe" },
  { old: "Expert Hexer's Robe", new: "Vile Robe" },
  { old: "Expert Keth Raiment", new: "Flowing Raiment" },
  { old: "Expert Altar Robe", new: "Sacramental Robe" },
  { old: "Advanced Chain Mail", new: "Ring Mail" },
  { old: "Advanced Rogue Armour", new: "Scoundrel Armour" },
  { old: "Advanced Vagabond Armour", new: "Wanderer Armour" },
  { old: "Advanced Cloaked Mail", new: "Mantled Mail" },
  { old: "Advanced Explorer Armour", new: "Trailblazer Armour" },
  { old: "Advanced Scale Mail", new: "Golden Mail" },
  { old: "Priestess Robe", new: "Sacramental Robe" },
  { old: "Expert Rogue Armour", new: "Dastard Armour" },
  { old: "Expert Cloaked Mail", new: "Shrouded Mail" },
  { old: "Expert Scale Mail", new: "Death Mail" },
  { old: "Advanced Pilgrim Vestments", new: "Templar Vestments" },
  { old: "Advanced Pelt Mantle", new: "Bearskin Mantle" },
  { old: "Advanced Mail Vestments", new: "Chain Vestments" },
  { old: "Advanced Shaman Mantle", new: "Occultist Mantle" },
  { old: "Advanced Ironclad Vestments", new: "Plated Vestments" },
  { old: "Advanced Sacrificial Mantle", new: "Heartcarver Mantle" },
  { old: "Expert Pelt Mantle", new: "Wolfskin Mantle" },
  { old: "Expert Shaman Mantle", new: "Conjurer Mantle" },
  { old: "Expert Sacrificial Mantle", new: "Death Mantle" },
  { old: "Advanced Hermit Garb", new: "Ascetic Garb" },
  { old: "Advanced Waxed Jacket", new: "Oiled Jacket" },
  { old: "Advanced Marabout Garb", new: "Evangelist Garb" },
  { old: "Advanced Wayfarer Jacket", new: "Itinerant Jacket" },
  { old: "Advanced Anchorite Garb", new: "Hatungo Garb" },
  { old: "Advanced Scalper's Jacket", new: "Hawker's Jacket" },
  { old: "Expert Waxed Jacket", new: "Sleek Jacket" },
  { old: "Expert Wayfarer Jacket", new: "Rambler Jacket" },
  { old: "Expert Scalper's Jacket", new: "Falconer's Jacket" },
  { old: "Advanced Rusted Greathelm", new: "Corroded Greathelm" },
  { old: "Advanced Soldier Greathelm", new: "Mercenary Greathelm" },
  { old: "Advanced Wrapped Greathelm", new: "Homeguard Greathelm" },
  { old: "Advanced Spired Greathelm", new: "Elegant Greathelm" },
  { old: "Advanced Elite Greathelm", new: "Noble Greathelm" },
  { old: "Expert Soldier Greathelm", new: "Warmonger Greathelm" },
  { old: "Expert Spired Greathelm", new: "Masked Greathelm" },
  { old: "Expert Elite Greathelm", new: "Paragon Greathelm" },
  { old: "Advanced Shabby Hood", new: "Rotted Hood" },
  { old: "Advanced Felt Cap", new: "Wool Cap" },
  { old: "Advanced Lace Hood", new: "Narrow Hood" },
  { old: "Advanced Swathed Cap", new: "Wrapped Cap" },
  { old: "Advanced Hunter Hood", new: "Deerstalker Hood" },
  { old: "Expert Felt Cap", new: "Woven Cap" },
  { old: "Expert Swathed Cap", new: "Desert Cap" },
  { old: "Expert Hunter Hood", new: "Trapper Hood" },
  { old: "Advanced Twig Circlet", new: "Druidic Circlet" },
  { old: "Advanced Wicker Tiara", new: "Avian Tiara" },
  { old: "Advanced Beaded Circlet", new: "Desert Circlet" },
  { old: "Advanced Chain Tiara", new: "Sandsworn Tiara" },
  { old: "Advanced Feathered Tiara", new: "Jungle Tiara" },
  { old: "Expert Wicker Tiara", new: "Skycrown Tiara" },
  { old: "Expert Chain Tiara", new: "Sorcerous Tiara" },
  { old: "Expert Feathered Tiara", new: "Kamasan Tiara" },
  { old: "Advanced Brimmed Helm", new: "Domed Helm" },
  { old: "Advanced Guarded Helm", new: "Engraved Helm" },
  { old: "Advanced Visored Helm", new: "Soldier Helm" },
  { old: "Advanced Cowled Helm", new: "Cabalist Helm" },
  { old: "Advanced Shielded Helm", new: "Gladiatoral Helm" },
  { old: "Expert Guarded Helm", new: "Warded Helm" },
  { old: "Expert Cowled Helm", new: "Cryptic Helm" },
  { old: "Expert Shielded Helm", new: "Champion Helm" },
  { old: "Advanced Iron Crown", new: "Mailed Crown" },
  { old: "Advanced Horned Crown", new: "Forest Crown" },
  { old: "Advanced Cultist Crown", new: "Zealot Crown" },
  { old: "Advanced Martyr Crown", new: "Hallowed Crown" },
  { old: "Advanced Heavy Crown", new: "Inquisitor Crown" },
  { old: "Expert Horned Crown", new: "Druidic Crown" },
  { old: "Expert Martyr Crown", new: "Saintly Crown" },
  { old: "Expert Heavy Crown", new: "Divine Crown" },
  { old: "Advanced Hewn Mask", new: "Oak Mask" },
  { old: "Advanced Face Mask", new: "Bandit Mask" },
  { old: "Advanced Hooded Mask", new: "Skulking Mask" },
  { old: "Advanced Veiled Mask", new: "Pariah Mask" },
  { old: "Advanced Tribal Mask", new: "Avian Mask" },
  { old: "Expert Face Mask", new: "Brigand Mask" },
  { old: "Expert Veiled Mask", new: "Faridun Mask" },
  { old: "Expert Tribal Mask", new: "Soaring Mask" },
  { old: "Advanced Riveted Mitts", new: "Plated Mitts" },
  { old: "Advanced Tempered Mitts", new: "Elegant Mitts" },
  { old: "Advanced Bolstered Mitts", new: "Ancient Mitts" },
  { old: "Advanced Moulded Mitts", new: "Feathered Mitts" },
  { old: "Expert Riveted Mitts", new: "Knightly Mitts" },
  { old: "Expert Bolstered Mitts", new: "Ornate Mitts" },
  { old: "Expert Moulded Mitts", new: "Vaal Mitts" },
  { old: "Advanced Firm Bracers", new: "Hunting Bracers" },
  { old: "Advanced Bound Bracers", new: "Swift Bracers" },
  { old: "Advanced Sectioned Bracers", new: "Refined Bracers" },
  { old: "Advanced Spined Bracers", new: "Spiked Bracers" },
  { old: "Expert Firm Bracers", new: "Stalking Bracers" },
  { old: "Expert Sectioned Bracers", new: "Grand Bracers" },
  { old: "Expert Spined Bracers", new: "Barbed Bracers" },
  { old: "Advanced Sombre Gloves", new: "Ominous Gloves" },
  { old: "Advanced Stitched Gloves", new: "Embroidered Gloves" },
  { old: "Advanced Jewelled Gloves", new: "Baroque Gloves" },
  { old: "Advanced Intricate Gloves", new: "Gold Gloves" },
  { old: "Expert Sombre Gloves", new: "Grim Gloves" },
  { old: "Expert Jewelled Gloves", new: "Opulent Gloves" },
  { old: "Expert Intricate Gloves", new: "Vaal Gloves" },
  { old: "Advanced Ringmail Gauntlets", new: "Ironmail Gauntlets" },
  { old: "Advanced Layered Gauntlets", new: "Captain Gauntlets" },
  { old: "Advanced Doubled Gauntlets", new: "Zealot Gauntlets" },
  { old: "Expert Ringmail Gauntlets", new: "Steelmail Gauntlets" },
  { old: "Expert Layered Gauntlets", new: "Commander Gauntlets" },
  { old: "Expert Doubled Gauntlets", new: "Cultist Gauntlets" },
  { old: "Advanced Rope Cuffs", new: "Braided Cuffs" },
  { old: "Advanced Aged Cuffs", new: "Heirloom Cuffs" },
  { old: "Advanced Goldcast Cuffs", new: "Ornate Cuffs" },
  { old: "Expert Rope Cuffs", new: "Bound Cuffs" },
  { old: "Expert Aged Cuffs", new: "Ancient Cuffs" },
  { old: "Expert Goldcast Cuffs", new: "Gleaming Cuffs" },
  { old: "Advanced Gauze Wraps", new: "Bandage Wraps" },
  { old: "Advanced Linen Wraps", new: "Cambric Wraps" },
  { old: "Advanced Spiral Wraps", new: "Adorned Wraps" },
  { old: "Expert Gauze Wraps", new: "War Wraps" },
  { old: "Expert Linen Wraps", new: "Elegant Wraps" },
  { old: "Expert Spiral Wraps", new: "Vaal Wraps" },
  { old: "Advanced Iron Greaves", new: "Plated Greaves" },
  { old: "Advanced Bronze Greaves", new: "Lionheart Greaves" },
  { old: "Advanced Trimmed Greaves", new: "Elegant Greaves" },
  { old: "Advanced Stone Greaves", new: "Carved Greaves" },
  { old: "Expert Iron Greaves", new: "Bulwark Greaves" },
  { old: "Expert Trimmed Greaves", new: "Ornate Greaves" },
  { old: "Expert Stone Greaves", new: "Vaal Greaves" },
  { old: "Advanced Laced Boots", new: "Bound Boots" },
  { old: "Advanced Embossed Boots", new: "Sleek Boots" },
  { old: "Advanced Steeltoe Boots", new: "Studded Boots" },
  { old: "Advanced Lizardscale Boots", new: "Serpentscale Boots" },
  { old: "Expert Laced Boots", new: "Cinched Boots" },
  { old: "Expert Steeltoe Boots", new: "Cavalry Boots" },
  { old: "Expert Lizardscale Boots", new: "Dragonscale Boots" },
  { old: "Advanced Wrapped Sandals", new: "Laced Sandals" },
  { old: "Advanced Lattice Sandals", new: "Bangled Sandals" },
  { old: "Advanced Silk Slippers", new: "Elegant Slippers" },
  { old: "Advanced Feathered Sandals", new: "Dunerunner Sandals" },
  { old: "Expert Wrapped Sandals", new: "Bound Sandals" },
  { old: "Expert Silk Slippers", new: "Luxurious Slippers" },
  { old: "Expert Feathered Sandals", new: "Sandsworn Sandals" },
  { old: "Soldiering Greaves", new: "Plated Greaves" },
  { old: "Advanced Mail Sabatons", new: "Soldiering Sabatons" },
  { old: "Advanced Braced Sabatons", new: "Goldwork Sabatons" },
  { old: "Advanced Stacked Sabatons", new: "Bastion Sabatons" },
  { old: "Veteran Greaves", new: "Bulwark Greaves" },
  { old: "Expert Mail Sabatons", new: "Veteran Sabatons" },
  { old: "Expert Braced Sabatons", new: "Noble Sabatons" },
  { old: "Expert Stacked Sabatons", new: "Fortress Sabatons" },
  { old: "Advanced Padded Leggings", new: "Adherent Leggings" },
  { old: "Advanced Secured Leggings", new: "Bound Leggings" },
  { old: "Advanced Pelt Leggings", new: "Shamanistic Leggings" },
  { old: "Expert Padded Leggings", new: "Faithful Leggings" },
  { old: "Expert Secured Leggings", new: "Apostle Leggings" },
  { old: "Expert Pelt Leggings", new: "Warlock Leggings" },
  { old: "Advanced Frayed Shoes", new: "Wayfarer Shoes" },
  { old: "Advanced Threaded Shoes", new: "Silverbuckled Shoes" },
  { old: "Advanced Hunting Shoes", new: "Treerunner Shoes" },
  { old: "Expert Frayed Shoes", new: "Wanderer Shoes" },
  { old: "Expert Threaded Shoes", new: "Charmed Shoes" },
  { old: "Expert Hunting Shoes", new: "Quickslip Shoes" },
  { old: "Advanced Painted Tower Shield", new: "Aged Tower Shield" },
  { old: "Advanced Braced Tower Shield", new: "Metalworked Tower Shield" },
  { old: "Advanced Effigial Tower Shield", new: "Cultist Tower Shield" },
  { old: "Advanced Rampart Tower Shield", new: "Bulwark Tower Shield" },
  { old: "Advanced Heraldric Tower Shield", new: "Noble Tower Shield" },
  { old: "Advanced Stone Tower Shield", new: "Goldworked Tower Shield" },
  { old: "Expert Braced Tower Shield", new: "Royal Tower Shield" },
  { old: "Expert Rampart Tower Shield", new: "Fortress Tower Shield" },
  { old: "Expert Stone Tower Shield", new: "Vaal Tower Shield" },
  { old: "Advanced Hardwood Targe", new: "Ironwood Targe" },
  { old: "Advanced Pelage Targe", new: "Fur-lined Targe" },
  { old: "Advanced Studded Targe", new: "Mercenary Targe" },
  { old: "Advanced Crescent Targe", new: "Polished Targe" },
  { old: "Advanced Chiseled Targe", new: "Stone Targe" },
  { old: "Advanced Feathered Targe", new: "Avian Targe" },
  { old: "Expert Pelage Targe", new: "Mammoth Targe" },
  { old: "Expert Crescent Targe", new: "Baroque Targe" },
  { old: "Expert Feathered Targe", new: "Soaring Targe" },
  { old: "Advanced Blazon Crest Shield", new: "Painted Crest Shield" },
  { old: "Advanced Sigil Crest Shield", new: "Engraved Crest Shield" },
  { old: "Advanced Emblem Crest Shield", new: "Descry Crest Shield" },
  { old: "Advanced Jingling Crest Shield", new: "Dekharan Crest Shield" },
  { old: "Advanced Sectarian Crest Shield", new: "Quartered Crest Shield" },
  { old: "Advanced Omen Crest Shield", new: "Glowering Crest Shield" },
  { old: "Expert Sigil Crest Shield", new: "Intricate Crest Shield" },
  { old: "Expert Jingling Crest Shield", new: "Sekheman Crest Shield" },
  { old: "Expert Omen Crest Shield", new: "Vaal Crest Shield" },
  { old: "Advanced Woven Focus", new: "Wreath Focus" },
  { old: "Advanced Antler Focus", new: "Staghorn Focus" },
  { old: "Advanced Tonal Focus", new: "Jingling Focus" },
  { old: "Advanced Crystal Focus", new: "Arrayed Focus" },
  { old: "Advanced Voodoo Focus", new: "Cultist Focus" },
  { old: "Advanced Plumed Focus", new: "Hallowed Focus" },
  { old: "Expert Antler Focus", new: "Druidic Focus" },
  { old: "Expert Crystal Focus", new: "Leyline Focus" },
  { old: "Expert Plumed Focus", new: "Sacred Focus" },
];
